import React from 'react';
import {createKeyDownHandler} from "../../../../../../../utils/keyDownHanlder";
import {ReactComponent as CheckCircleIco} from "../../../../../../../../images/icons/check-circle.svg";
import Money from "../../../../../../../components/Common/Money";
import StoreUtils from "../../../../../../../services/Store/StoreUtils";
import {ConfigApi} from "../../../../../../../services/Api/types";

interface Props {
    option: Record<string, any>;
    isProductAvailable: boolean;
    modifierGroup: Record<string, any>;
    changeQuantity: (option: Record<string, any>) => void;
    priceDisplayMode: "mixed" | "allPaid" | "allFree" | undefined;
    config: ConfigApi | undefined;
}

const ProductModifierGroupSingleSelectOption = ({
                                                    option,
                                                    isProductAvailable,
                                                    modifierGroup,
                                                    changeQuantity,
                                                    priceDisplayMode,
                                                    config
                                                }: Props) => {
    const isReadonly = StoreUtils.isOrderingReadonly(config);
    const checked = isReadonly ? false : !!option.state;
    const disabled = isReadonly ? false : !isProductAvailable || option.disabled;

    const handleChange = () => {
        if (isReadonly) return;

        if (disabled) return;

        changeQuantity(option);
    }

    const handleOnKeyDown = () => createKeyDownHandler<HTMLDivElement>({
        keys: ["Enter", " "],
        preventDefault: true,
        action: () => handleChange()
    });

    const renderPrice = () => {
        if (!priceDisplayMode || priceDisplayMode === "allFree") return <></>;

        const moneyComponent = <Money value={option.price}/>;

        if (priceDisplayMode === "allPaid") {
            return moneyComponent;
        }

        if (priceDisplayMode === "mixed") {
            return (
                <>
                    {option.price > 0 ? "+" : ""}
                    {moneyComponent}
                </>
            )
        }
    }

    return (
        <div
            className={`product-item-option product-single-select-option ${checked ? "active" : ""} ${disabled ? "disabled" : ""} ${isReadonly ? "not-clickable" : ""}`}
            onClick={handleChange}
            aria-checked={checked} tabIndex={0} onKeyDown={handleOnKeyDown()}>
            <input type="radio" checked={checked}
                   name={`modifierGroup-${modifierGroup.id}-options`}
                   id={`modifierGroup-${modifierGroup.id}-item-${option.id}`}
                   value={option.id}/>
            {checked && (
                <div className="check-circle">
                    <CheckCircleIco/>
                </div>
            )}
            <label htmlFor={`modifierGroup-${modifierGroup.id}-item-${option.id}`}>
                <span className="item-name">
                   {option.name}
                </span>
                <span className="item-price">
                   {renderPrice()}
                </span>
            </label>
        </div>
    )
}

export default ProductModifierGroupSingleSelectOption;